import {useCallback, useEffect, useMemo} from "react";
import useApiRequest from "../../hooks/useApiRequest";
import SearchBar from "../ui/SearchBar";
import {SCOPE_ACTION_OPTIONS, SCOPE_OWNERSHIP_OPTIONS} from "../../constants/searchFields";

const normalizeArray = (value) => {
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.results)) return value.results;
  if (Array.isArray(value)) return value;
  return [];
};

const ClientScopesFilterBar = ({clientId, onSearch}) => {
  const {list: listProducts} = useApiRequest({baseUrl: "/products", resource: "products"});

  const loadProducts = useCallback(async () => {
    const res = await listProducts();
    return normalizeArray(res?.data).map((p) => ({id: p.id, label: p.name || p.id}));
  }, [listProducts]);

  // Reset the grid whenever the selected client changes.
  useEffect(() => {
    onSearch({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  const fields = useMemo(
    () => [
      {field: "product_id", label: "Producto", type: "autocomplete", width: 220, loadOptions: loadProducts},
      {field: "resource", label: "Recurso", type: "text", width: 160},
      {field: "subresource", label: "Subrecurso", type: "text", width: 160},
      {field: "ownership", label: "Alcance", type: "select", width: 160, options: SCOPE_OWNERSHIP_OPTIONS},
      {field: "action", label: "Acción", type: "select", width: 160, options: SCOPE_ACTION_OPTIONS}
    ],
    [loadProducts]
  );

  // key={clientId} remounts (and thus clears) the bar when the client changes.
  return (
    <div style={{marginBottom: 16}}>
      <SearchBar key={clientId} fields={fields} onSearch={onSearch} />
    </div>
  );
};

export default ClientScopesFilterBar;
